import React, { memo } from "react";
import { Box, useTheme } from "@mui/material";

import { LeftBox } from "./LeftBox";
import { CenterBox } from "./CenterBox";
import { RightBox } from "./RightBox";
import { useAppContext } from "../../context/appContext";

function AppSectionHeader({ type, admins = [], users = [] }) {
  const { appInDarkMode, isMobile } = useAppContext();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: isMobile ? "3rem" : "6rem", // ✅ fixed + consistent
        px: 2, // ✅ replaces margins
        backgroundColor: appInDarkMode
          ? "transparent"
          : theme.palette.background.paper,
      }}
    >
      {/* ✅ LEFT */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <LeftBox type={type} />
      </Box>

      {/* ✅ CENTER */}
      {!isMobile && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1, // ✅ takes remaining space
            px: 1,
          }}
        >
          <CenterBox type={type} />
        </Box>
      )}

      {/* ✅ RIGHT */}
      {!isMobile && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <RightBox type={type} admins={admins} users={users} />
        </Box>
      )}
    </Box>
  );
}

export default memo(AppSectionHeader);
